export function convertMillisecondsToHoursAndMinutes(
    milliseconds: number
): string {
    // Convert milliseconds to seconds
    const seconds = Math.floor(milliseconds / 1000);

    // Convert seconds to minutes
    const minutes = Math.floor(seconds / 60);

    // Convert minutes to hours
    const hours = Math.floor(minutes / 60);

    // Calculate the remaining minutes
    const remainingMinutes = minutes % 60;

    // Format the result as a string
    return `${hours}h${remainingMinutes}m`;
}
